import { jsx } from 'react/jsx-runtime';
import Icon from './Icon.js';

var UpIcon = Icon(jsx("polygon", { points: "24,12 0,12 12,0 " }), '0 0 24 12', 'UpIcon');

export { UpIcon as default };
